import shaka from 'shaka-player';
import youbora from 'youboralib';
import { completeWithDefaults, DEFAULT_AD_OPTIONS } from './utils.js';
import 'lodash/defaults';
import 'lodash/mapValues';

var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _adManager, _adManagerListeners, _options, _registerCustomListeners, registerCustomListeners_fn;
const { ads: { AdManager } } = shaka;
class NpawAdsAdapterShaka extends youbora.Adapter {
  constructor(adManager, options = {}) {
    super();
    __privateAdd(this, _registerCustomListeners);
    /** @type {shaka.extern.IAdManager} */
    __privateAdd(this, _adManager, void 0);
    /** @type {{ type: string, listener: () => void }[]} */
    __privateAdd(this, _adManagerListeners, []);
    /**
     * @type {{
     *  errorParser: (error: any) => ({ name: string, description: string, metadata?: any }),
     *  getErrorDetails: (error: any) => any
     * }}
     */
    __privateAdd(this, _options, DEFAULT_AD_OPTIONS);
    __privateSet(this, _adManager, adManager);
    __privateSet(this, _options, completeWithDefaults(options, DEFAULT_AD_OPTIONS));
    __privateMethod(this, _registerCustomListeners, registerCustomListeners_fn).call(this);
  }
  unregisterListeners() {
    for (const { type, listener } of __privateGet(this, _adManagerListeners)) {
      __privateGet(this, _adManager).removeEventListener(type, listener);
    }
    __privateSet(this, _adManagerListeners, []);
  }
  /**
   * @param {shaka.util.FakeEvent} event
   */
  adStarted(event) {
    const { ad } = event;
    this.plugin.setOptions({
      "ad.creativeId": ad?.getCreativeAdId(),
      "ad.duration": ad?.getDuration(),
      "ad.title": ad?.getTitle()
    });
    this.fireStart();
  }
  adPaused() {
    this.firePause();
  }
  adResumed() {
    this.fireResume();
  }
  adFirstQuartile() {
    this.fireQuartile(1);
  }
  adMidPoint() {
    this.fireQuartile(2);
  }
  adThirdQuartile() {
    this.fireQuartile(3);
  }
  adCompleted() {
    this.fireStop();
  }
  adRecoverableError(event) {
    if (event.shakaError) {
      const { name, description, metadata } = __privateGet(this, _options).errorParser(event.shakaError);
      const details = metadata || __privateGet(this, _options).getErrorDetails(event.shakaError);
      this.fireError(name, description, details, "error", "adRecoverableError");
    }
  }
  adError(event) {
    if (event.shakaError) {
      const { name, description, metadata } = __privateGet(this, _options).errorParser(event.shakaError);
      const details = metadata || __privateGet(this, _options).getErrorDetails(event.shakaError);
      this.fireFatalError(name, description, details, "fatal", "adError");
    }
  }
  adClicked() {
    this.fireClick();
  }
  adSkipped() {
    this.fireSkip();
  }
  adBuffering(event) {
    if (event.buffering) {
      this.fireBufferBegin();
    } else {
      this.fireBufferEnd();
    }
  }
  adBreakEnd() {
    this.fireAdBreakStop();
  }
  dispose() {
    if (this.isDisposed)
      return;
    super.dispose();
    this.isDisposed = true;
    __privateSet(this, _adManager, void 0);
  }
}
_adManager = new WeakMap();
_adManagerListeners = new WeakMap();
_options = new WeakMap();
_registerCustomListeners = new WeakSet();
registerCustomListeners_fn = function() {
  __privateSet(this, _adManagerListeners, [
    { type: AdManager.AD_STARTED, listener: this.adStarted.bind(this) },
    { type: AdManager.AD_PAUSED, listener: this.adPaused.bind(this) },
    { type: AdManager.AD_RESUMED, listener: this.adResumed.bind(this) },
    { type: AdManager.AD_FIRST_QUARTILE, listener: this.adFirstQuartile.bind(this) },
    { type: AdManager.AD_MIDPOINT, listener: this.adMidPoint.bind(this) },
    { type: AdManager.AD_THIRD_QUARTILE, listener: this.adThirdQuartile.bind(this) },
    { type: AdManager.AD_COMPLETE, listener: this.adCompleted.bind(this) },
    { type: AdManager.AD_RECOVERABLE_ERROR, listener: this.adRecoverableError.bind(this) },
    { type: AdManager.AD_ERROR, listener: this.adError.bind(this) },
    { type: AdManager.AD_CLICKED, listener: this.adClicked.bind(this) },
    { type: AdManager.AD_SKIPPED, listener: this.adSkipped.bind(this) },
    { type: "ad-buffering", listener: this.adBuffering.bind(this) },
    { type: "breakEnd", listener: this.adBreakEnd.bind(this) }
  ]);
  for (const { type, listener } of __privateGet(this, _adManagerListeners)) {
    __privateGet(this, _adManager).addEventListener(type, listener);
  }
};

export { NpawAdsAdapterShaka };
//# sourceMappingURL=NpawAdsAdapterShaka.js.map
